module.exports = __webpack_public_path__ + "assets/icon_study_highlight.798b9a42.svg";